import { ProductType } from 'domain/Product';
import { Nullable } from 'utils/types';
import { useSelector } from 'react-redux';
import { getCaseData } from '../store/selectors';
import { State } from 'modules/cm/store/cases/types';
import { Product } from '../store/cases/products/types';

export const productTypeChecker = (selectedProductType: Nullable<ProductType>) => (type: ProductType) =>
  selectedProductType === type;

const useProductType = () => {
  const caseData = useSelector(getCaseData);
  const productsState = useSelector(({ currentCase }: { currentCase: State }) => currentCase.products);
  const formProductCode = caseData.case.loanDetails.productCode;

  const found: Product | undefined = productsState.find((product: Product) => product.code === formProductCode);

  const isProductType = productTypeChecker(found ? found.type : null);

  return {
    isRIO: isProductType('RIO'),
    isTIO: isProductType('TIO'),
    productTypeChecker: (productCode: string) => {
      const found: Product | undefined = productsState.find((product: Product) => product.code === productCode);
      return productTypeChecker(found ? found.type : null);
    },
  };
};

export default useProductType;
